var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"notifications-list-item\">Nothing here yet</div>");;return buf.join("");
};
module.exports = template;